<template>
  <div class="cj">
    <div class="page page1" v-if="page == 1">
      <div class="total-num">
        <span class="text">当前抽奖码总数</span>
        <span class="num">{{ codeTotal }}</span>
      </div>
      <div class="time">
        <div class="border">{{ hour }}</div>
        <img class="split" src="@/assets/image/Cj/split.png" />
        <div class="border">{{ minute }}</div>
        <img class="split" src="@/assets/image/Cj/split.png" />
        <div class="border">{{ seconds }}</div>
      </div>
    </div>
    <div class="page page2" v-if="page == 2">
      <div class="time">
        <div class="counter-container">
          <div class="counter">
            <div class="counter-item" v-for="i in 5" :key="i">
              <div class="counter-item__inner">
                <div
                  class="counter-item__inner-digit"
                  :style="{
                    transform: `translateY(${Number(
                      numberString.charAt(i + 1)
                    ) * -100}%)`
                  }"
                >
                  <div class="counter-item__inner-digit-list"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-for="(v, k) in code" :key="k" class="border">
          {{ v }}
        </div> -->
      </div>
    </div>
    <div class="page page3" v-if="page == 3">
      <div class="total-num">
        <span class="text">今日参加活动人数</span>
        <span class="num">{{ registerNum }}</span>
      </div>
      <div class="progress">
        <el-progress
          :text-inside="true"
          :stroke-width="45"
          :percentage="percentage"
          :color="'#F8EA92'"
          :define-back-color="'#f0f0f0'"
          :show-text="false"
        ></el-progress>
        <div class="iconBar">
          <img src="@/assets/image/Cj/arrow_left.png" />
          <img class="iconImg" src="@/assets/image/Cj/iconBar.png" />
          <img class="iconImg" src="@/assets/image/Cj/iconBar.png" />
          <img class="iconImg" src="@/assets/image/Cj/iconBar.png" />
          <img src="@/assets/image/Cj/arrow_right.png" />
        </div>
        <div class="bar-legend">
          <div :class="{ arrive: percentage > 25 }" class="legend">
            <span>2500</span>
            <p>人</p>
          </div>
          <div :class="{ arrive: percentage > 50 }" class="legend">
            <span>5000</span>
            <p>人</p>
          </div>
          <div :class="{ arrive: percentage > 75 }" class="legend">
            <span>7500</span>
            <p>人</p>
          </div>
          <div :class="{ arrive: percentage == 100 }" class="legend">
            <span>10000</span>
            <p>人</p>
          </div>
        </div>
      </div>
      <img
        class="pxIcon"
        :class="[pxPostion]"
        src="@/assets/image/Cj/pxIcon.png"
      />
    </div>
  </div>
</template>
<script>
const { VUE_APP_CJ_API } = process.env;
import {
  registerStatics,
  getCodeCount,
  getSetting,
  getCode,
  getCountDown
} from "@/request/API";
export default {
  name: "cj",
  props: {},
  data() {
    return {
      page: 1,
      registerNum: 0,
      code: 0,
      codeTotal: 0,
      SI: null,
      hour: "00",
      minute: "00",
      seconds: "00",
      nearTime: "",
      socket: null,
      startVal: 0,
      endVal: 999
    };
  },
  methods: {
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      return [hourTime, minuteTime, secondTime];
    },
    counter() {
      let newTime = new Date().getTime();
      let timeGap = (new Date(this.nearTime).getTime() - newTime) / 1000;
      let format = this.formatSeconds(timeGap);
      this.hour = format[0] < 10 ? `0${format[0]}` : format[0];
      this.minute = format[1] < 10 ? `0${format[1]}` : format[1];
      this.seconds = format[2] < 10 ? `0${format[2]}` : format[2];
    },
    wsConnect() {
      let _this = this;
      this.socket = null;
      console.log(VUE_APP_CJ_API, process.env, "VUE_APP_CJ_API");
      this.socket = new WebSocket(VUE_APP_CJ_API);
      this.socket.onopen = function() {
        console.log("WebSocket连接已建立");
      };
      this.socket.onmessage = function(event) {
        const message = JSON.parse(event.data);
        console.log("message.code", message.code, message);

        //进入展示抽奖码界面
        if (message.prize_code) {
          _this.page = 2;
          setTimeout(() => {
            _this.code = message.prize_code;
          }, 100);
          localStorage.setItem("cjCode", message.prize_code);
          localStorage.setItem("cjPage", 2);
          console.log(this.page, "this.page this.page ");
        }

        ///是否进入倒计时界面
        console.log(message, message.is_count_down, "message.is_count_down");
        if (message.is_count_down == 1) {
          _this.page = 1;

          //获取当前抽奖码总数
          _this.getCodeCountData();
          //获取倒计时配置
          getSetting().then(res => {
            _this.nearTime = "";
            let newTime = new Date().getTime();
            console.log(res.data.drawing_time, "res.data.drawing_time");
            for (let k of res.data.drawing_time) {
              if (new Date(k).getTime() > newTime) {
                _this.nearTime = k;
                break;
              }
            }
            localStorage.setItem("cjPage", 1);
            localStorage.setItem("cjTime", _this.nearTime);
            _this.SI = setInterval(() => {
              console.log(
                new Date(_this.nearTime).getTime(),
                new Date().getTime(),
                new Date(_this.nearTime).getTime() < new Date().getTime()
              );
              if (
                _this.nearTime == "" ||
                new Date(_this.nearTime).getTime() < new Date().getTime()
              ) {
                _this.hour = "00";
                _this.minute = "00";
                _this.seconds = "00";
                clearInterval(_this.SI);
                return;
              }
              _this.counter();
            }, 1000);
          });
        } else {
          clearInterval(_this.SI);
          _this.hour = "00";
          _this.minute = "00";
          _this.seconds = "00";
        }
      };

      this.socket.onclose = function(event) {
        console.log("WebSocket连接已关闭");
        // location.reload();
        _this.wsConnect();
        _this.restartWs();
      };

      this.socket.onerror = function(error) {
        console.error("WebSocket错误：", error);
        // _this.wsConnect()
      };
    },
    //获取当前注册人数
    getRegister() {
      registerStatics().then(res => {
        this.registerNum = res.data.count;
      });
    },
    getCodeCountData() {
      getCodeCount().then(res => {
        console.log(res.data, "获取当前抽奖码总数");
        this.codeTotal = res.data;
      });
    },
    restartWs() {
      if (
        this.page == 1 &&
        new Date(this.nearTime).getTime() - new Date().getTime() > 0
      ) {
        setTimeout(() => {
          this.SI = setInterval(() => {
            if (
              this.nearTime == "" ||
              new Date(this.nearTime).getTime() < new Date().getTime()
            ) {
              this.hour = "00";
              this.minute = "00";
              this.seconds = "00";
              clearInterval(this.SI);
              return;
            }
            this.counter();
          }, 1300);
        }, 100);
      }
    }
  },
  mounted() {
    this.code = 0;
    console.log(localStorage.getItem("cjCode"), 'localStorage.getItem("cjCode")')
    setTimeout(() => {
      this.code =
        (localStorage.getItem("cjCode") && localStorage.getItem("cjCode")) || 0;
    }, 100);
    this.page = localStorage.getItem("cjPage") || 2;
    this.nearTime = localStorage.getItem("cjTime") || "";
    console.log(this.page, this.nearTime, this.code, "cjPage");
    this.page = this.$route.query.register ? 3 : this.page;
    if (this.page == 3) {
      this.getRegister();
      setInterval(() => {
        this.getRegister();
      }, 5000);
    } else {
      if (this.page == 1) {
        this.getCodeCountData();
        setInterval(() => {
          this.getCodeCountData();
        }, 3000);
      }
      this.wsConnect();
    }
    this.restartWs();
    console.log(this.SI, "SI");
  },
  watch: {},
  computed: {
    pxPostion() {
      console.log(this.percentage, "this.percentage");
      if (this.percentage >= 0 && this.percentage < 25) {
        return "pxIcon1";
      } else if (this.percentage > 25 && this.percentage < 50) {
        return "pxIcon2";
      } else if (this.percentage > 50 && this.percentage < 75) {
        return "pxIcon3";
      } else {
        return "pxIcon4";
      }
    },
    percentage() {
      return (Number(this.registerNum) / 10000) * 100;
    },
    numberString() {
      return String(this.code).padStart(this.total, "0");
    }
  },
  created() {
    this.total = 7;
  }
};
</script>
<style lang="less" scoped>
::v-deep .el-progress-bar__outer {
  background-color: #fdc169;
}

.cj {
  width: 100vw;
  height: 100vh;
  background: gold;
  position: fixed;
  z-index: 999999;

  .page {
    width: 100vw;
    height: 100vh;
    font-size: 20px;
    color: white;
    position: fixed;
    top: 0;
    left: 0;
  }
  .page1 {
    background: url(../../assets/image/Cj/bg1.png);
    background-size: cover;
    .total-num {
      top: 170px;
      position: fixed;
      width: 100%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .text {
        font-size: 60px;
      }
      .num {
        font-size: 76px;
        color: #cc6d11;
        font-weight: 800;
        margin-left: 25px;
      }
    }
    .time {
      font-size: 217px;
      color: white;
      font-weight: 900;
      position: fixed;
      width: 100%;
      display: flex;
      top: 456px;
      justify-content: center;
      .border {
        width: 398px;
        height: 398px;
        background: url(../../assets/image/Cj/border.png);
        background-size: cover;
        font-size: 217px;
        color: #7b3f05;
        text-align: center;
        line-height: 398px;
      }
      .split {
        height: 140px;
        margin: 125px 105px 125px;
      }
    }
  }
  .page2 {
    background: url(../../assets/image/Cj/bg2.png);
    background-size: cover;
    .time {
      font-size: 300px;
      color: white;
      font-weight: 900;
      position: fixed;
      width: 100%;
      display: flex;
      top: 600px;
      //top: 22.396vw;
      justify-content: center;
      // .border {
      //   width: 598px;
      //   height: 596px;
      //   background: url(/img/border.1d1ba5fe.png);
      //   font-size: 339px;
      //   color: #7b3f05;
      //   text-align: center;
      //   line-height: 596px;
      //   background-size: cover;
      //   margin-left: 31px;
      // }
      .counter-container {
        width: 244px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        transform: scale(9);
        //margin-top: 300px;
        //margin-top: 15.625vw;
        .counter {
          display: flex;
          font-size: 32px;
          color: #7b3f05;
          font-weight: bold;
          text-align: center;
          &-item {
            width: 36px;
            height: 36px;
            background: url(/img/border.1d1ba5fe.png);
            //background-size: 320px 320px;
            margin-right: 5px;
            background-size: cover;
            &:last-of-type {
              margin-right: 9px;
            }
            &__inner {
              position: relative;
              overflow: hidden;
              &-digit {
                transition: 3s transform;
                height: 36px;
                line-height: 36px;
                &-list {
                  &::before {
                    display: block;
                    content: "0\a 1\a 2\a 3\a 4\a 5\a 6\a 7\a 8\a 9\a ";
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .page3 {
    .total-num {
      top: 60px;
      position: fixed;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 55px;
      .text {
        font-size: 49px;
      }
      .num {
        font-size: 68px;
        color: #7b3f05;
        font-weight: 800;
        margin-left: 22px;
      }
    }
    background: url(../../assets/image/Cj/bg3.png);
    background-size: cover;
    .progress {
      position: fixed;
      width: 92%;
      bottom: 117px;
      margin-left: 4%;
      .iconBar {
        width: 102%;
        position: absolute;
        display: flex;
        height: 77px;
        justify-content: space-between;
        margin: -63px 0 0 -1%;
      }
      .bar-legend {
        width: 100%;
        position: absolute;
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        .legend {
          width: 25%;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 69px;
            font-weight: 800;
          }
          p {
            font-size: 47px;
            font-weight: 700;
            margin: 10px 0 0 5px;
          }
        }
        .arrive {
          color: #7b3f05;
        }
      }
    }
    .pxIcon {
      width: 165px;
      height: 126px;
      position: fixed;
      left: 164px;
      top: 318px;
    }
    .pxIcon1 {
      left: 164px;
    }
    .pxIcon2 {
      left: 638px;
    }
    .pxIcon3 {
      left: 1108px;
    }
    .pxIcon4 {
      left: 1587px;
    }
  }
}
</style>
